import { Component, OnInit, ViewEncapsulation, Inject, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SharedService } from './shared/shared.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    busySpinner: boolean = false;
    jsPanelSpinner: boolean = false;

    constructor(private _sharedService: SharedService,
        @Inject(DOCUMENT) private document: Document,
        private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.beforeInstallPrompt();
        this._sharedService.busySpinner.subscribe((show) => {
            this.busySpinner = show;
            if (show) {
                this.document.body.classList.add("has-busy-spinner");
            } else {
                this.document.body.classList.remove("has-busy-spinner");
            }
            this.cd.detectChanges();
        });
        this._sharedService.jsPanelSpinner.subscribe((show) => {
            this.jsPanelSpinner = show;
            this.cd.detectChanges();
        });
    }

    beforeInstallPrompt() {
        let component = this;
        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            component._sharedService.pwaPrompt.next(e);
            // Optionally, send analytics event that PWA install promo was shown.
            console.log(`'beforeinstallprompt' event was fired.`);
        });
    }

}
